import { ProductAdditives } from '../../../../services/exports/Constants';

export default {
  title: 'Additivi',
  options: {
    [ProductAdditives.AcesulfamK]: 'Acesulfame K',
    [ProductAdditives.AceSucralose]: 'Ace-Sucralosio',
    [ProductAdditives.Aesculin]: 'Esculina',
    [ProductAdditives.Agar]: 'Agar',
    [ProductAdditives.Anthocyanin]: 'Antocianina',
    [ProductAdditives.Antioxidant]: 'Antiossidante',
    [ProductAdditives.AntioxidantAscorbicAcid]: 'Antiossidante: Acido ascorbico',
    [ProductAdditives.AntioxidantTocopherols]: 'Antiossidante: Tocoferoli',
    [ProductAdditives.Flavor]: 'Aroma',
    [ProductAdditives.Flavors]: 'Aromi',
    [ProductAdditives.AscorbicAcid]: 'Acido ascorbico',
    [ProductAdditives.Aspartame]: 'Aspartame',
    [ProductAdditives.OysterSauce]: 'Salsa di ostriche',
    [ProductAdditives.BakingAid]: 'Agente lievitante',
    [ProductAdditives.BakingPowder]: 'Lievito in polvere',
    [ProductAdditives.BalsamicVinegar]: 'Aceto balsamico',
    [ProductAdditives.BalsamicCream]: 'Crema balsamica',
    [ProductAdditives.BasilPesto]: 'Pesto al basilico',
    [ProductAdditives.BenzoicAcid]: 'Acido benzoico',
    [ProductAdditives.BetaCarotene]: 'Beta-carotene',
    [ProductAdditives.Betain]: 'Betaina',
    [ProductAdditives.BeetrootRed]: 'Rosso di barbabietola',
    [ProductAdditives.Beeswax]: "Cera d'api",
    [ProductAdditives.Bitters]: 'Bitter',
    [ProductAdditives.BlueCuracao]: 'Blue Curaçao',
    [ProductAdditives.BlueCuracaoSyrup]: 'Sciroppo Blue Curaçao',
    [ProductAdditives.BrandyVinegar]: 'Aceto di brandy',
    [ProductAdditives.Broth]: 'Brodo',
    [ProductAdditives.Caffeine]: 'Caffeina',
    [ProductAdditives.Calcium]: 'Calcio',
    [ProductAdditives.Caramel]: 'Caramello',
    [ProductAdditives.CaramelColor]: 'Colorante caramello',
    [ProductAdditives.CaramelE150d]: 'Caramello E150d',
    [ProductAdditives.Carotene]: 'Carotene',
    [ProductAdditives.CayennePepper]: 'Pepe di Cayenna',
    [ProductAdditives.Chili]: 'Peperoncino',
    [ProductAdditives.ChiliDressing]: 'Condimento al peperoncino',
    [ProductAdditives.ChiliMayonnaise]: 'Maionese al peperoncino',
    [ProductAdditives.ChiliOil]: 'Olio al peperoncino',
    [ProductAdditives.Quinine]: 'Chinino',
    [ProductAdditives.Chlorophyll]: 'Clorofilla',
    [ProductAdditives.CitricAcid]: 'Acido citrico',
    [ProductAdditives.CitrusAcid]: 'Acido degli agrumi',
    [ProductAdditives.CarbonDioxide]: 'Anidride carbonica (CO₂)',
    [ProductAdditives.CocktailSauce]: 'Salsa cocktail',
    [ProductAdditives.Curry]: 'Curry',
    [ProductAdditives.CurryPaste]: 'Pasta di curry',
    [ProductAdditives.CurryPowder]: 'Curry in polvere',
    [ProductAdditives.CurryCreamSauce]: 'Salsa cremosa al curry',
    [ProductAdditives.Fragrance]: 'Fragranza',
  },
};
